export default "__VITE_ASSET__Dpl6oOn$__"